import axios from '@/plugins/axios'
import util from '@/services/util'

const ibeaconApiEndPoint = 'admin/ibeacon'

export default {
    namespaced: true,

    state: {
        ibeacons: [],
        total: 0
    },

    getters: {
        getIBeaconById: state => id => {
            const ibeacon = state.ibeacons.find(ibeacon => ibeacon.id === id)
            if (ibeacon) {
                return JSON.parse(JSON.stringify(ibeacon))
            }

            return null
        }
    },

    mutations: {
        setIBeacons (state, ibeacons) {
            state.ibeacons = ibeacons
        },

        setIBeaconTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchIBeacons (context, query) {
            const response = await axios.get(util.buildUrlWithQuery(ibeaconApiEndPoint, query))
            const { ibeacons, total } = response
            context.commit('setIBeacons', ibeacons)
            context.commit('setIBeaconTotal', total)
        },

        async updateIBeacon (context, payload) {
            await axios.patch(`${ibeaconApiEndPoint}/${payload.id}`, payload)
            await context.dispatch('fetchIBeacons', {
                sortBy: 'major',
                sortType: 'ASC'
            })
        }
    }
}
